import React from "react";
import { IPageBreakPartProps } from "../../models";
//import css from "../../form.module.scss";

const PageBreak = ({style, breakAfter = false}: IPageBreakPartProps) => {
  //return <div>TEST</div>;
  return (<div className={breakAfter ? "pageBreakAfter" : "pageBreakBefore"} style={style} />);
}

export default PageBreak;






